<template>
  <download-excel :data="dados" :fields="excel.fields" :name="excel.name">
    <v-btn title="Baixar tabela" icon color="blue lighten-3">
      <v-icon>fal fa-cloud-download</v-icon>
    </v-btn>
  </download-excel>
</template>

<script>
export default {
  props: ['dados', 'excel']
}
</script>